
module.exports = {
    api: {
        basePath:  "https://dev.battlemythe.net/api",
        socketPath: "https://dev.battlemythe.net"
    }
};
